import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'

import { Button } from 'reactstrap'
import { authSelector, departmentSelector, lobSelector } from './../../../selectors'
import { departmentAction, lobAction } from './../../../actions/'
import CustomModalMessage from '../../../components/modal-message'
import DepartmentForm from '../../../components/department'

class CreateDepartment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      department_code: '',
      department: '',
      lob_id: '',
      edit: false,
      createModal: false,
      id: '',
      modalDelete: false,
      modalCancel: false,
      activeTab: '1',
      start_date: '',
      is_active: true,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.deactivateDepartment = this.deactivateDepartment.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
  }
  componentDidMount() {
    this.props.listLOB(localStorage.getItem('access_token'))
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'departmentGet')) {
      this.setState({
        department_code: get(nextProps, 'departmentGet.department_code'),
        department: get(nextProps, 'departmentGet.name'),
        lob_id: get(nextProps, 'departmentGet.lob_id'),
        start_date: get(nextProps, 'departmentGet.start_date') ? get(nextProps, 'departmentGet.start_date') : '',
        is_active: get(nextProps, 'departmentGet.is_active'),
      })
      this.props.resetGetDepartment()
    }
    if (get(nextProps, 'edit')) {
      if (get(nextProps, 'edit.edit')) {
        this.setState({ id: get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getDepartment(get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetDepartment()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDelete() {
    this.deactivateDepartment()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  deactivateDepartment() {
    this.props.deactivateDepartment(get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  submitForm() {
    if (get(this.state, 'edit')) {
      this.props.editDepartment(
        get(this.state, 'id'),
        {
          department_code: this.state.department_code,
          name: this.state.department,
          lob_id: this.state.lob_id,
          start_date: this.state.start_date === '' ? '' : moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
      /* eslint no-underscore-dangle: 0 */
      <div>
        {
          get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ get(this.props, 'confirmType') === 'confirmDelete' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        { get(this.props, 'confirmType') === 'confirmDiscard' &&
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        }
        <DepartmentForm
          edit={ this.state.edit }
          list={ get(this.props, 'listLOBData') }
          department_code={ this.state.department_code }
          department={ this.state.department }
          lob_id={ this.state.lob_id }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          button={ button }
          confrim={ get(this.props, 'confirm') }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          handleInput={ this.handleInput }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

CreateDepartment.propTypes = {
  editDepartment: PropTypes.func.isRequired,
  resetGetDepartment: PropTypes.func.isRequired,
  getDepartment: PropTypes.func.isRequired,
  listLOB: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  deactivateDepartment: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  departmentCreate: departmentSelector.getCreateDepartmentData,
  departmentEdit: departmentSelector.getEditDepartmentData,
  departmentGet: departmentSelector.getGetDepartmentData,
  departmentDeactivate: departmentSelector.getDeactivateDepartmentData,
  listLOBData: lobSelector.getListLOB,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createDepartment: departmentAction.createDepartment,
  resetCreateDepartment: departmentAction.resetCreateDepartment,
  editDepartment: departmentAction.editDepartment,
  resetEditDepartment: departmentAction.resetEditDepartment,
  getDepartment: departmentAction.getDepartmentByID,
  resetGetDepartment: departmentAction.resetGetDepartment,
  listLOB: lobAction.getLOB,
  listDepartment: departmentAction.getDepartment,
  deactivateDepartment: departmentAction.deactivateDepartment,
  resetDeactivateDepartment: departmentAction.resetDeactivateDepartment,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CreateDepartment)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/department/edit/index.js